import { Platform, View } from 'react-native'
import { DealType } from '@ca/common/types'
import { useBrandFilter } from '@order/hooks/useBrandFilter'
import Brand from './BrandLogo'
import { colors } from '@ui/colors'
import { BlurView } from 'expo-blur'
import Gradient from '@ui/effects/Gradient'

interface Props {
  types?: DealType[]
}

const borderRadius = 32

export default function IntroBrands({ types }: Props) {
  const brandFilter = useBrandFilter({ types })
  const brandIds = brandFilter.brandOptions.map((o) => o.id)

  return (
    <View
      className="relative flex w-full flex-row items-center justify-center gap-8 self-center overflow-hidden"
      style={{
        top: 8,
        height: 48 + 32 + 32,
        borderRadius,
      }}
    >
      <BlurView
        tint="prominent"
        intensity={Platform.select({ default: 40, web: 100 })}
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          borderRadius,
        }}
      />
      <Gradient
        colors={[colors.white0, colors.white50, colors.white75]}
        start={[0.5, 0]}
        end={[0.5, 1]}
        style={{ width: '100%', height: '100%', borderRadius }}
      />
      {brandIds.map((brandId, index) => (
        <Brand
          key={brandId}
          brandId={brandId}
          index={index}
          total={brandIds.length}
        />
      ))}
    </View>
  )
}
